import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react'
import { BiCog } from 'react-icons/bi';
import { Link, useLocation } from 'react-router-dom';
import { MdArrowDropDown } from "react-icons/md";

const NestedLink = ({ Icon, title, to, links }) => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const hovered = links.find(item => item.to === pathname);
  return (
    <>
      <button type="button" onClick={() => setOpen(!open)} href="#" className="w-full block flex group items-center space-x-2">
        <div className={`w-[35%] transition-all group-hover:bg-primary/20  py-4 rounded-tr-full rounded-br-full flex justify-end pr-4 `}>
          <Icon className={`text-2xl text-white group-hover:text-white`} />
        </div>
        <span className={`font-medium text-white group-hover:text-white text-xs ${hovered ? "text-white" : ""}`}>
          {title}
        </span>
        <MdArrowDropDown className={`transition-all text-xl mt-1 text-white group-hover:text-white transform ${open ? "rotate-[180deg]" : "rotate=[0deg]"}`} />
      </button>
      <AnimatePresence>
        {
          open &&
          <motion.div
            initial={{ height: "0" }}
            animate={{ height: "auto" }}
            exit={{ height: "0" }}
            className="overflow-hidden"
          >
            {
              links.map((item, index) => (
                <Link key={index} to={item.to} className="flex group items-center space-x-2">
                  <div className={`w-[40%] transition-all group-hover:bg-secondary/20  py-4 rounded-tr-full rounded-br-full flex justify-end pr-4 ${pathname === item.to ? "bg-secondary" : ""}`}>
                    <item.icon className={`text-xl text-white group-hover:text-white ${pathname === item.to ? "text-white" : ""}`} />
                  </div>
                  <span className={`font-medium text-white group-hover:text-white text-xs ${pathname === to ? "text-white" : ""}`}>
                    {item.title}
                  </span>
                </Link>
              ))
            }
          </motion.div>

        }
      </AnimatePresence>
    </>
  )
}

export default NestedLink